import React, { Component } from 'react';
import Decks2d from './Decks2d';
import { GameStateBar } from './GameStateBar';
import ScoreBars from '../Components/Views/ScoreBars';

import './game-2d-menu.css'

const GAME_STATUS_NAMES = [
    null,
    'Starting', 'Started', 'Taking Turns',
    'Scoring', 'Win', 'Saving',
    'Round Setup', 'Ghost Starter', 'Draft',
    'ERROR', 'Game Loaded', 'Player Loaded',
    'Taking Turn', 'Waiting',
    'Open', 'Lobby', 'Ghost Starter 2']


export default class Game2dMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        if (!this.props.gameData) return
        // let secondsRemaining = 0;
        let gameStatusName = GAME_STATUS_NAMES[this.props.gameData.status_name];
        // let currentPlayerId = this.props.gameData.current_player;
        // let currentPlayer = this.props.gameData.gameplayer_set.find(gamePlayer => gamePlayer.id===currentPlayerId);
        // if (currentPlayer && currentPlayer.seconds_remaining) {
        //     secondsRemaining = currentPlayer.seconds_remaining;
        //     gameStatusName = GAME_STATUS_NAMES[currentPlayer.game_status]
        // }

        return <div className={'game-top-bar'}>
            <div className={'game-menu-item game-menu-round-number'}>
                &#128257;{this.props.gameData.current_round}
            </div>
            <div className={'game-menu-item'}>
                {gameStatusName}
            </div>
            <div className={'game-menu-item'}>
                <GameStateBar {...this.props} />
            </div>
            <div className={'game-menu-item'}>
                <Decks2d {...this.props} />
            </div>
            {/* <div className={'game-menu-item game-menu-countdown-timer'}> */}
            {/*     &#x23f1;{new Date(secondsRemaining * 1000).toISOString().substring(14, 19)} */}
            {/* </div> */}
        </div>
    }

}
